import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

/**
 * Firebase is used for one thing: proving to our API which Google account is
 * signing in. The ID token it mints is handed to the API and the Firebase
 * session is thrown away immediately — the console's own session token is the
 * only thing that survives the login screen.
 *
 * The config arrives at RUNTIME from /config.js, not from VITE_ variables baked
 * into the bundle, because this image ships to every environment unchanged and a
 * project rotation should be an env change rather than a rebuild. (Lazior-cp
 * bakes them in; that is the difference, not a mistake in either.)
 *
 * None of these four values is a secret. A Firebase web apiKey identifies the
 * project to Google's servers; it authorises nothing on its own. What actually
 * gates access is the API refusing a token whose email has no console account.
 */
declare global {
  interface Window {
    LAZIOR_FB_API_KEY?: string;
    LAZIOR_FB_AUTH_DOMAIN?: string;
    LAZIOR_FB_PROJECT_ID?: string;
    LAZIOR_FB_APP_ID?: string;
  }
}

export const firebaseConfigured = Boolean(
  window.LAZIOR_FB_API_KEY && window.LAZIOR_FB_AUTH_DOMAIN && window.LAZIOR_FB_PROJECT_ID,
);

const app = firebaseConfigured
  ? initializeApp({
      apiKey: window.LAZIOR_FB_API_KEY,
      authDomain: window.LAZIOR_FB_AUTH_DOMAIN,
      projectId: window.LAZIOR_FB_PROJECT_ID,
      appId: window.LAZIOR_FB_APP_ID,
    })
  : null;

export const firebaseAuth = app ? getAuth(app) : null;
export const googleProvider = new GoogleAuthProvider();
